import routerGuard from '@/helpers/routerGuard'

const routes = [{
    path: '/AddAssetCheckList/:id',
    name: 'AddAssetCheckList',
    //beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/CompanyUserView/AssetCheckList/AddAssetCheckList.vue'),
    meta: { moduleCode: 6004 }
},
{
    path: '/viewmonthlycontent',
    name: 'ViewMonthlyContent',
    // beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/MonthlyContent/monthlyContent.vue'),
    //beforeEnter: routerGuard.guardMyroute,
    meta: { moduleCode: 1010 }
},
{
    path: '/monthlycontentdetail/:id',
    name: 'MonthlyContentDetail',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/MonthlyContent/monthlyContentDetail.vue'),
    //beforeEnter: routerGuard.guardMyroute,
    meta: { moduleCode: 1010 }
},
{
    path: '/Course',
    name: 'CompanyManageCourse',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/Managecourse/manageCourse.vue'),
    meta: { moduleCode: 1009 }
},
{
    path: '/Course/CourseDetail/:id',
    name: 'CompanyManageCourseDetail',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/Managecourse/courseDetail.vue'),
    meta: { moduleCode: 1009 }
},

{
    path: '/manageambassadormonthlycontent',
    name: 'Manage Monthly Contents',
    //  beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/CompanyUserView/MonthlyContent/manageMonthlyContent.vue'),
    meta: { moduleCode: 10140 }
},
{
    path: '/manageambassadormonthlycontent/create',
    name: 'AddMonthlyContent',
    component: () =>
        import('@/CompanyUserView/MonthlyContent/addEditMonthlyContent.vue'),
    //  beforeEnter: routerGuard.guardMyroute,
    meta: { moduleCode: 10140 }
},
{
    path: '/manageambassadormonthlycontent/edit/:id',
    name: 'MonthlyContentEdit',
    component: () =>
        import('@/CompanyUserView/MonthlyContent/addEditMonthlyContent.vue'),
    meta: { moduleCode: 10140 }
    // beforeEnter: routerGuard.guardMyroute,
},
{
    path: '/favourites',
    name: 'Manage Favorites',
    component: () =>
        import('@/CompanyUserView/ManageFavourite/favouriteList.vue'),
    meta: { moduleCode: 1005 }
},
{
    path: '/sendEmailToClient/:id',
    name: 'sendEmailToClient',
    component: () =>
        import('@/CompanyUserView/ManageFavourite/sendEmailToClient.vue'),
    meta: { moduleCode: 1005 }
    //beforeEnter: guardMyroute,
},
{
    path: '/ownedProperties',
    name: 'ownedProperties',
    component: () =>
        import('@/CompanyUserView/ManageOwnedProperties/ownedPropertiesList.vue'),
    meta: { moduleCode: 1004 }
    //beforeEnter: guardMyroute,
},
{
    path: '/receivedRequest/:id/:BookingId/:ShareId',
    name: 'receivedRequest',
    component: () =>
        import('@/CompanyUserView/ManageOwnedProperties/receivedRequestList.vue'),
    meta: { moduleCode: 1004 }
    // beforeEnter: guardMyroute,
},
{
    path: '/userBookProperty/:id/:shareid',
    name: 'userBookProperty',
    component: () =>
        import('@/CompanyUserView/ManageOwnedProperties/userBookedProperty.vue'),
    meta: { moduleCode: 1004 }
    //beforeEnter: guardMyroute,
},

{
    path: '/VactionSwapMarketplace',
    name: 'VactionSwapMarketplace',
    component: () =>
        import('@/CompanyUserView/VacationSwap/VacationSwapMarketplace.vue'),
    meta: { moduleCode: 1012 }
},
{
    path: '/vactionSwapMarketplacedetail/:assetId/:shareid/:bookingId',
    name: 'VactionSwapMarketPlaceDetail',
    component: () =>
        import('@/CompanyUserView/VacationSwap/vacationSwapMarketplaceDetails.vue'),
    meta: { moduleCode: 1012 }
},
{
    path: '/membershipdetail',
    name: 'memberShipDetail',
    //beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/CompanyUserView/MemberShip/memberShipDetail.vue'),
    meta: { moduleCode: 1011 }
},

{
    path: '/MeetingSchedule',
    name: 'manageMeetingSchedule',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/ManageScheduleMeetings/manageMeetingSchedule.vue'),
    meta: { moduleCode: 9003 }
},

{
    path: '/assetreviewlist',
    name: 'assetreviewlist',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/Assetreview/assetreviewlist.vue'),
    meta: { moduleCode: 9004 }

},
{
    path: '/myprofile',
    name: 'myprofile',
    component: () =>
        import('@/CompanyUserView/MyProfile/myProfile.vue'),
    meta: { moduleCode: 1014 }
    // beforeEnter: routerGuard.guardMyroute,
},
{
    path: '/clientRegistration',
    name: 'clientRegistration',
    component: () =>
        import('@/CompanyUserView/Registration/clientRegistration.vue'),
    /* meta: { moduleCode: }*/
    // beforeEnter: routerGuard.guardMyroute,
},
{
    path: '/AreaofInterestList',
    name: 'AreaofInterestList',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/AreaofInterest/AreaofInterestList.vue'),
    meta: { moduleCode: 1006 }
},
{
    path: '/addeditAreaofInterest',
    name: 'addeditAreaofInterest',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/AreaofInterest/addeditAreaofInterest.vue'),
    meta: { moduleCode: 1006 }
},

{
    path: '/EditbyId/:id',
    name: 'EditAreaofinterest',
    component: () =>
        import('@/CompanyUserView/AreaofInterest/addeditAreaofInterest.vue'),
    meta: { moduleCode: 1006 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/managearticles',
    name: 'manageArticles',
    component: () =>
        import('@/CompanyUserView/ManageArticles/manageArticles.vue'),
    meta: { moduleCode: 1007 }
    /*   beforeEnter: routerGuard.guardMyroute,*/
},
{
    path: '/articleDetail/:id',
    name: 'articleDetail',
    component: () =>
        import('@/CompanyUserView/ManageArticles/articleDetail.vue'),
    /*meta: { moduleCode: }*/
    meta: { moduleCode: 1007 }
    /* beforeEnter: guardMyroute,*/
},

{
    path: '/editcontact/:id',
    name: 'editcontactById',
    component: () =>
        import('@/CompanyUserView/ManageOwnedProperties/editcontact.vue'),
    meta: { moduleCode: 1004 }
    //beforeEnter: guardMyroute,
},
{
    path: '/ticket',
    name: 'Manage Tickets',
    component: () =>
        import('@/CompanyUserView/ManageTicket/ticketList.vue'),
    meta: { moduleCode: 7011 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/ticket/:id',
    name: 'Manage Ticket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/ticketList.vue'),
    meta: { moduleCode: 7011 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/ticket/addTicket',
    name: 'Add Ticket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/addTicket.vue'),
    meta: { moduleCode: 7011 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/viewTicket/:id',
    name: 'viewTicket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/ticketDetail.vue'),
    meta: { moduleCode: 7011 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/editTicket/:id',
    name: 'EditTicket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/addTicket.vue'),
    meta: { moduleCode: 7011 }
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/ticket/editticket/:id',
    name: 'Manage ticket | Edit ticket',
    beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/CompanyUserView/ManageTicket/addTicket.vue'),
    meta: { moduleCode: 7011 }
},

{
    path: '/addeditcontact/:id',
    name: 'Manage Clients | Add/Edit Client ',
    component: () =>
        import('@/CompanyUserView/ManageContacts/AddContact.vue'),
    meta: { moduleCode: 1008 }
    //beforeEnter: guardMyroute,
},
{
    path: '/ManageContacts',
    name: 'Manage Clients',
    component: () =>
        import('@/CompanyUserView/ManageContacts/Contacts.vue'),
    meta: { moduleCode: 1008 }
    //beforeEnter: guardMyroute,
},
{
    path: '/shareLink',
    name: 'shareLink',
    component: () =>
        import('@/CompanyUserView/ManageContacts/shareLink.vue'),
    meta: { moduleCode: 1008 }
    //beforeEnter: guardMyroute,
},
{
    path: '/addcontact',
    name: 'Manage Clients | Add/Edit Client',
    component: () =>
        import('@/CompanyUserView/ManageContacts/AddContact.vue'),
    meta: { moduleCode: 1008 }
    //beforeEnter: guardMyroute,
},
{
    path: '/editcontact/:id',
    name: 'editcontact',
    component: () =>
        import('@/CompanyUserView/ManageContacts/AddContact.vue'),
    meta: { moduleCode: 1008 }
    //beforeEnter: guardMyroute,
},
{
    path: '/ManageDocument',
    name: 'ManageDocuments',
    component: () =>
        import('@/CompanyUserView/ManageDocument/manageDocument.vue'),
    /*meta: { moduleCode: }*/
},
{
    path: '/ManageDocument/addeditDocument',
    name: 'AddEditdocument',
    component: () =>
        import('@/CompanyUserView/ManageDocument/addeditDocument.vue'),
    /*meta: { moduleCode: }*/
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/ManageDocument/addeditDocument/:id',
    name: 'Editdocument',
    component: () =>
        import('@/CompanyUserView/ManageDocument/addeditDocument.vue'),
    /*meta: { moduleCode: }*/
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/assignedTicket',
    name: 'Manage Assigned Tickets',
    component: () =>
        import('@/CompanyUserView/ManageTicket/manageAssignedTicketList.vue'),
    meta: { moduleCode: 9011013 }
},
{
    path: '/assignedTicket/:id',
    name: 'Manage Assigned Ticket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/manageAssignedTicketList.vue'),
    meta: { moduleCode: 9011013 }
},
{
    path: '/ManageNotification',
    name: 'ManageNotification',
    component: () =>
        import('@/CompanyUserView/dashboard/Notification.vue'),
    meta: { moduleCode: 7012 },
    /* beforeEnter: guardMyroute,*/
},
{
    path: '/assignedAgentTicket',
    name: 'Manage Assignet Tickets',
    component: () =>
        import('@/CompanyUserView/ManageTicket/assignedTicketForAgentList.vue'),
    meta: { moduleCode: 10101010 }
},
{
    path: '/assignedAgentTicket/:id',
    name: 'Manage Assignet Ticket',
    component: () =>
        import('@/CompanyUserView/ManageTicket/assignedTicketForAgentList.vue'),
    meta: { moduleCode: 10101010 }
},
{
    path: '/assetPublishedlist',
    name: 'assetPublishedlist',
    //beforeEnter: guardMyroute,
    component: () =>
        import('@/CompanyUserView/AssetPublished/assetPublishedlist.vue'),
    meta: { moduleCode: 45784 }

},
{
    path: '/propertycontactinformation',
    name: 'contactinformation',
    component: () =>
        import('@/CompanyUserView/managecontactinfo/contactinformation.vue'),
    meta: { moduleCode: 15258 }
},
{
    path: '/CommissionReport',
    name: 'Commission Report',
    component: () =>
        import('@/views/commissionReport/commissionReport.vue'),
    meta: { moduleCode: 101010 }
},
{
    path: '/rentPropertiesList',
    name: 'rentPropertiesList',
    component: () =>
        import('@/CompanyUserView/ManageOwnedProperties/rentPropertiesList.vue'),
    meta: { moduleCode: 4017 }

},
{
    path: '/VactionSwapMarketplacerequestedStatus',
    name: 'VactionSwapMarketplacerequestedStatus',
    component: () =>
        import('@/CompanyUserView/VacationSwap/VacationSwapMarketPlaceRequestStatus.vue'),
    meta: { moduleCode: 1012 }
},
{
    path: '/AssetMapping',
    name: 'AssetMapping',
    component: () =>
        import('@/CompanyUserView/AssetMapping/AssetMapping.vue'),
    meta: { moduleCode: 1012 }
},
{
    path: '/MappedAsset',
    name: 'Mappped Asset',
    component: () =>
        import('@/CompanyUserView/MappedAssetList/MappedAsset.vue'),
},
{
    path: '/AssetMapping/:state/:code/:error/:error_description',
    name: 'AssetMappings',
    component: () =>
        import('@/CompanyUserView/AssetMapping/AssetMapping.vue'),
    meta: { moduleCode: 1012 }
},
{
    path: '/AddCancellationPolicy',
    name: 'Manage Cancellation Policies | Add/Edit Cancellation Policy',
    // beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/views/managecompwebsites/manageCancellationpolicy/AddCancellationPolicy.vue'),
    meta: { moduleCode: 6010 }
},
{
    path: '/EditCancellationPolicy/:id',
    name: 'Edit CancellationPolicy',
    // beforeEnter: routerGuard.guardMyroute,
    component: () =>
        import('@/views/managecompwebsites/manageCancellationpolicy/AddCancellationPolicy.vue'),
    meta: { moduleCode: 6010 }
},
{
    path: '/configureExternalSource',
    name: 'Configure External Source',
    component: () =>
        import('@/CompanyUserView/AssetMapping/configureExternalSource.vue'),
},
{
    path: '/assetDocumentProcess',
    name: 'Asset Buy Process',
    component: () =>
        import('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyProcessList.vue'),
},
{
    path: '/assetBuyDocument/:id',
    name: 'Asset Document Process',
    component: () =>
        import('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyDocumentProcess.vue'),
},
{
    path: '/assetBuyDocument',
    name: 'Asset Document Processes',
    component: () =>
        import('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyDocumentProcess.vue'),
},
{
    path: '/ManageCancellationPolicy',
    name: 'Manage Cancellation Policies',
    component: () =>
        import('@/views/managecompwebsites/manageCancellationpolicy/ManageCancellationPolicyList.vue'),
    meta: { moduleCode: 6010 }
},
{
    path: '/ManageESignDocument',
    name: 'E-Sign Documents',
    component: () =>
        import('@/CompanyUserView/ManageESignDocument/eSignDocumentList.vue'),
},
{
    path: '/addeditform/:module/:subModule/:systemgenerated/:formMasterId',
    name: 'addeditform',
    component: () =>
        import('@/views/crm/configurationsetting/manageform/addEditForm/addeditform.vue'),
}
]
export default routes